function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.33398 5L0.970181 4.657C0.788585 4.84961 0.788585 5.15039 0.970181 5.343L1.33398 5ZM5.46902 1.343C5.65846 1.14207 5.64914 0.825629 5.44822 0.636197C5.24729 0.446764 4.93085 0.45608 4.74142 0.657003L5.46902 1.343ZM4.74142 9.343C4.93085 9.54392 5.24729 9.55324 5.44822 9.3638C5.64914 9.17437 5.65846 8.85793 5.46902 8.657L4.74142 9.343ZM10.6673 5.5C10.9435 5.5 11.1673 5.27614 11.1673 5C11.1673 4.72386 10.9435 4.5 10.6673 4.5V5.5ZM1.69779 5.343L5.46902 1.343L4.74142 0.657003L0.970181 4.657L1.69779 5.343ZM5.46902 8.657L1.69779 4.657L0.970181 5.343L4.74142 9.343L5.46902 8.657ZM1.33398 5.5H10.6673V4.5H1.33398V5.5Z",
  fill: "url(#leftArrowPaint)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "leftArrowPaint",
  x1: 10.6673,
  y1: 5,
  x2: 1.33398,
  y2: 5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B2FF"
})));

function SvgArrowLeftGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGradient);
export default __webpack_public_path__ + "static/media/ArrowLeftGradient.d18903de60617a7b7e9e0524aca6a45b.svg";
export { ForwardRef as ReactComponent };